import OpCheck from './OpCheck';
import './style/index.less';

export default OpCheck;
